export const SITE_URL = 'https://reikinearme.co';

interface QueryParams {
  [key: string]: string;
}

/**
 * Generates a canonical URL for a given path
 * @param path - The path to generate a canonical URL for (e.g., '/blog', '/about')
 * @param params - Optional query parameters to include in the URL
 * @returns The full canonical URL
 */
export function getCanonicalUrl(path: string, params?: QueryParams): string {
  // Remove leading slash if present in path
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // Construct the base URL
  let url = `${SITE_URL}${cleanPath ? `/${cleanPath}` : ''}`;
  
  // Add query parameters if provided
  if (params && Object.keys(params).length > 0) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.append(key, value);
      }
    });
    const queryString = searchParams.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
  }
  
  return url;
}

/**
 * Formats a URL-safe slug from a string
 * @param str - The string to convert to a slug
 * @returns A URL-safe slug
 */
export function createSlug(str: string): string {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
} 